export const reportingMain: angular.IComponentOptions = {
  template: require('./reporting_main.html')
};




// WEBPACK FOOTER //
// ./src/app/reporting/reporting_main.ts